import { render, staticRenderFns } from "./MobileCheckout.vue?vue&type=template&id=2536a77a&scoped=true&"
import script from "./MobileCheckout.vue?vue&type=script&lang=js&"
export * from "./MobileCheckout.vue?vue&type=script&lang=js&"
import style0 from "./MobileCheckout.vue?vue&type=style&index=0&id=2536a77a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2536a77a",
  null
  
)

export default component.exports